import { render, staticRenderFns } from "./Testhome.vue?vue&type=template&id=f7c9c0bc&scoped=true&"
import script from "./Testhome.vue?vue&type=script&lang=js&"
export * from "./Testhome.vue?vue&type=script&lang=js&"
import style0 from "./Testhome.vue?vue&type=style&index=0&id=f7c9c0bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c9c0bc",
  null
  
)

export default component.exports